import React from 'react';
import reframe from 'nike-re-framejs';
import { denormalizeSportEventId } from '@/nikeone/domain/sportevent';
import AnimateHeight from 'react-animate-height';
import { LiveTicketScoreboardNg } from '@/scoreboards/views/liveScoreboardTicket/LiveScoreboardNg';
import TicketScoreboardPrematch from './TicketScoreboardPrematch';
import moment from 'moment';
import './TicketScoreboardNg.less';
import DataStateEnum from '@/common/dataState';
import i18n from '@i18n';
import { getClassNameByBet } from 'nike-ui/src/common/utils/utils';

function TicketScoreboardNg({ bet, isExpanded, virtual }) {
    const derefSub = reframe.useReframe();
    const eventId = denormalizeSportEventId(bet.get('betEventId'));
    const dataState = virtual ? DataStateEnum.EMPTY : derefSub(['ticketus/scoreboard/is-loaded', String(eventId)]);
    if (virtualStartedBet(bet)) {
        return null;
    }
    if (bet.get('status') === 'Registered' && moment(bet.get('expirationDate')).isAfter()) {
        return (
            <AnimateHeight height={isExpanded ? 'auto' : 0}>
                <TicketScoreboardPrematch bet={bet} />
            </AnimateHeight>
        );
    }

    return (
        <>
            {isExpanded && dataState === DataStateEnum.PENDING ? (
                <div className="linear-loader ticket-detail-scoreboard-loader" />
            ) : null}
            <AnimateHeight height={isExpanded && dataState !== DataStateEnum.PENDING ? 'auto' : 0}>
                <div className="ticketScoreboard">
                    {dataState === DataStateEnum.EMPTY ? (
                        <div className="dummy-scoreboard-wrap">
                            <div className={'dummy-scoreboard scoreboard-bg ' + getClassNameByBet(bet)}>
                                {i18n('ticket.detail.dataLoadFailed')}
                            </div>
                        </div>
                    ) : null}
                    {dataState === DataStateEnum.DATA ? (
                        <LiveTicketScoreboardNg subsPrefix="scoreboard" eventId={eventId} bet={bet} />
                    ) : null}
                </div>
            </AnimateHeight>
        </>
    );
}

export function virtualStartedBet(bet) {
    return moment(bet.get('expirationDate')).isBefore() && bet.get('betType') === 'Virtual';
}

export default TicketScoreboardNg;
